import React from 'react';
import {
  CopyMarketRequest,
  Market,
  SetupArea,
  useMarketsAdminService
} from 'nekst-api';
import { AfterSubmitFunc, FormTemplate, TextArea, TextInput } from 'ui-builder';
import { StateDropdown } from 'features/tasks-forms';
import useSettingsNavigator from '../../settingsNavigator';
import { Separator, TimezoneDropdown } from 'features/nekst-widgets';

export default function CopyMarketForm(
  props: {
    setupArea: SetupArea,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const marketsService = useMarketsAdminService();

  const settingsNavigator= useSettingsNavigator();

  const market = props.setupArea.market;

  if (market) {
    return (
      <FormTemplate<CopyMarketRequest, Market>
        title="Copy Market"
        submitFormFunc={async (data) => {
          return await marketsService.copyMarket(market.id, data);
        }}
        afterSubmitFunc={async (data) => {
          settingsNavigator.openAdminSetupAreaVersionPage(
            data.setupArea.market?.state,
            data.setupArea.id,
            data.setupArea.versions[0].version
          );
          await props.afterSubmitFunc?.(data);
        }}
        validationSchema={{
          name: {
            type: 'string',
            constraints: {
              required: true,
            },
          },
          alias: {
            type: 'string',
            constraints: {
              required: true,
              minLength: 3,
              maxLength: 30,
              regex: {
                value: /^[a-zA-Z0-9\\-]+$/,
                message: 'Alias must start with a letter and can only contain letters and numbers.'
              }
            }
          },
          version: {
            type: 'string',
            constraints: {
              required: true,
              minLength: 3,
              maxLength: 12,
              regex: {
                value: /^[a-zA-Z0-9\\-]+$/,
                message: 'Version can only contain letters, numbers, and dashes.'
              }
            }
          },
          state: {
            type: 'string',
            constraints: {
              required: true,
            },
          },
          description: {
            type: 'string',
            constraints: {
              required: false,
            },
          },
        }}
        initialData={{
          name: `${market.name} (copy)`,
          state: market.state,
          description: market.description || '',
          timezone: props.setupArea.timezone,
        }}
      >
        <TextInput source="name" label="Market Name" />
        <TextInput source="alias" label="Alias" />
        <StateDropdown source="state" label="State" />
        <TimezoneDropdown source="timezone" label="Timezone" placeholder="Select timezone" />
        <TextArea source="description" label="Description" />
        <Separator />
        <TextInput source="version" label="Version" />
      </FormTemplate>
    );
  }

}
